import { Fragment } from 'react';

import { Td } from '../../summary/components/Td.tsx';

export const SummaryTableExtraCells = ({
  count,
  span,
  suppressBorder,
  isFirstRow,
}: {
  count: number;
  span: number;
  suppressBorder?: boolean;
  isFirstRow?: boolean;
}) => (
  <>
    {new Array(count).fill(undefined).map((_, idx) => (
      <Td
        key={`fill-cell-${idx}`}
        width="25%"
        colSpan={span}
        isFirstRow={isFirstRow}
        border={suppressBorder ? '0 !important' : undefined}
      />
    ))}
  </>
);
